// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__EWHMz","root":"styles_root__h_lXN","typography":"styles_typography__KesV2","hightLight":"styles_hightLight__VAfLn","mobile":"styles_mobile__JGU_e"};